export { SectionTitle, SectionTitleSmall, CenteredSectionTitle } from './SectionTitle.styles';
